
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/about",
      function () {
        return require("private-next-pages/article/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/about"])
      });
    }
  